import { useMutation } from 'react-query';

import { axios } from '@/lib/axios';
import { queryClient } from '@/lib/react-query';

type UpdateFolderStatusDTO = {
  folderId: string;
  folderTypologyId: string;
  data: { folderStatusId: string };
};

const updateFolderStatusAsync = ({ folderId, data }: UpdateFolderStatusDTO) =>
  axios.put(`/folders/${folderId}/status`, {
    folderStatusId: data?.folderStatusId || null,
  });

export const useUpdateFolderStatusAsync = () =>
  useMutation({
    mutationFn: updateFolderStatusAsync,
    onSuccess: (_, { folderId, folderTypologyId }) => {
      setTimeout(() => {
        queryClient.invalidateQueries(['crossing-info-banner', folderId, folderTypologyId]);
        queryClient.invalidateQueries(['lifeline', folderId]);
      }, 1500);
    },
  });
